// Ported from eb-ui `src/legacy/components/CollectionHero/CollectionHero.tsx`.
// The legacy `import '../../styles/main.scss'` is REMOVED — the app's
// `src/styles/cc.scss` (loaded once in `_app`) already compiles the `cc-hero*`
// rules, so re-importing would double-load the styles.
import React, { ReactNode, useContext } from 'react';

import { AUTOCREATED_COLLECTION_DEFAULT_IMAGE_URL } from '../../_shared/constants';
import {
    isAutocreatedCollectionPreviewWithTips,
    isAutocreatedCollectionUnedited,
} from '../../_shared/utils';
import { ApplicationContext } from '../../context';
import type { CollectionServerData } from '@/types';

export const CollectionHero: React.FC<{ children?: ReactNode }> = ({
    children,
}) => {
    const context = useContext(ApplicationContext) as
        | CollectionServerData
        | null;
    const heroImage =
        isAutocreatedCollectionUnedited(context?.collection) &&
        isAutocreatedCollectionPreviewWithTips(context)
            ? AUTOCREATED_COLLECTION_DEFAULT_IMAGE_URL
            : context?.collection?.image?.url;

    return (
        <div role="banner" className="cc-hero">
            {heroImage ? (
                <div aria-label="Hero Image" className="cc-hero__image-wrapper">
                    <picture data-testid="collection-hero-image">
                        <source srcSet={heroImage} sizes="100vw" />
                        <img alt={''} />
                    </picture>
                </div>
            ) : null}

            <div
                className="cc-hero__button-share"
                aria-label="Share collection"
            >
                {children}
            </div>
        </div>
    );
};
